//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file dxos/mesh/teleport/auth.proto.
 */
export const file_dxos_mesh_teleport_auth = /*@__PURE__*/ fileDesc("Ch1keG9zL21lc2gvdGVsZXBvcnQvYXV0aC5wcm90bxIXZHhvcy5tZXNoLnRlbGVwb3J0LmF1dGgiKAoTQXV0aGVudGljYXRlUmVxdWVzdBIRCgljaGFsbGVuZ2UYASABKAwiKgoUQXV0aGVudGljYXRlUmVzcG9uc2USEgoKY3JlZGVudGlhbBgBIAEoDDJ6CgtBdXRoU2VydmljZRJrCgxBdXRoZW50aWNhdGUSLC5keG9zLm1lc2gudGVsZXBvcnQuYXV0aC5BdXRoZW50aWNhdGVSZXF1ZXN0Gi0uZHhvcy5tZXNoLnRlbGVwb3J0LmF1dGguQXV0aGVudGljYXRlUmVzcG9uc2ViBnByb3RvMw");
/**
 * Describes the message dxos.mesh.teleport.auth.AuthenticateRequest.
 * Use `create(AuthenticateRequestSchema)` to create a new message.
 */
export const AuthenticateRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_auth, 0);
/**
 * Describes the message dxos.mesh.teleport.auth.AuthenticateResponse.
 * Use `create(AuthenticateResponseSchema)` to create a new message.
 */
export const AuthenticateResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_auth, 1);
/**
 * @generated from service dxos.mesh.teleport.auth.AuthService
 */
export const AuthService = /*@__PURE__*/ serviceDesc(file_dxos_mesh_teleport_auth, 0);
//# sourceMappingURL=auth_pb.js.map